<template>
    <div class="container-services-points">
        <div class="container-services-points-header">
            <div class="text">
                Informe todos os locais no qual o cliente irá interagir com
                a equipe do evento. Esses locais deverão escanear o
                QR Code existente na etiqueta de identificação do cliente
                antes de iniciar os devidos procedimentos.
            </div>
        </div>

        <div class="container-services-points-name">
            <ui-input v-model="form.name" label="Nome:" placeholder="Digite..." required />

            <ui-select-v2
                v-model="form.control_id"
                :data="controls"
                :show-footer="false"
                :loading="loadControls"
                design="mgb-15 br-all"
                item-label="name"
                return-value="id"
                placeholder="Selecione"
                label="Controle:"
                required
            />

            <div class="button">
                <ui-engine
                    :data="form"
                    :disabled="!canAdd"
                    url="points"
                    design="md primary text-button"
                    service="launchDay"
                    method="create"
                    @input="loadData"
                />
            </div>
        </div>

        <div class="container-services-points-table">
            <div class="services-points-table">
                <table-services-points :contents="data" />
            </div>
        </div>

        <div class="container-services-points-footer">
            <ui-engine :next="next" :disabled="!$mx_hasValue(data)" name-button="Avançar" />
        </div>

    </div>
</template>

<script>
	import { uiInput, uiSelectV2 } from '@/components/ui/form'
	import { launchDay } from '@/services/axios'
	import tableServicesPoints from './table-services-points'
	import uiEngine from '../engine'

	import { utilMixin } from '@/mixins'

	import { mapActions, mapGetters } from 'vuex'

	const formDefault = () => ({
		name: '',
		control_id: null,
		launchday_id: null
	})

	export default {
		name: 'ui-launch-services-points',

		components: {
			uiInput,
			uiSelectV2,
			tableServicesPoints,
			uiEngine
		},

		mixins: [utilMixin],

		data() {
			return {
				data: [],
				controls: [],
				next: { name: 'launch.management.create.boxOperators', index: 1 },
				form: { ...formDefault() },
				loadControls: true
			}
		},

		computed: {
			...mapGetters('launchDay', { config: 'getConfig' }),
			/**
			 * Computed property que define se o cadastro de um ponto de atendimento pode prosseguir
			 */
			canAdd() {
				return this.$mx_hasValue(this.form.launchday_id) &&
					this.$mx_hasValue(this.form.name) &&
					this.$mx_hasValue(this.form.control_id)
			}
		},

		created() {
			this.$root.$on('modal-msg-launch-points-method-delete-response', () => {
				this.loadData()
			})
		},

		mounted() {
			this.loadData()
			launchDay.getAll('controls').then( res => { this.controls = res.data })
		},

		beforeDestroy() {
			this.$root.$off('modal-msg-launch-points-method-delete-response')
		},

		methods: {
			...mapActions('launchDay', ['setNextLoad']),
			/**
			 * Carrega os dados do lançamento atual
			 */
			loadData() {
				if (!this.config?.id) {
					this.$router.push({ name: 'launch.management.create.mainData' })
					return
				}

				this.setNextLoad(true)
				launchDay.get('points/launchday_id', this.config.id)
					.then(response => {
						this.data = [...response.data]
						this.form = {
							name: '',
							control_id: '',
							launchday_id: this.config.id
						}
						this.$root.$emit('stop-load-launchday', false)
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.error(error)
						this.$router.push({ name: 'launch.management' })
					})
					.finally(() => {
						this.loadControls = false
						this.setNextLoad(false)
					})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>